export const KEY_DS_TAB_TIEP_NHAN = "DSTIEPNHAN";
export const KEY_TAB_CHI_DINH_MAU = "CHIDINHMAU";
export const KEY_DS_TAB_HEN_KHAM = "DSHenKham";
export const KEY_DS_TAB_BENH_AN_DIEN_TU = "DSBENHANDIENTU";
export const KEY_DS_TAB_TIEP_DON = "DSTIEPDON";
export const KEY_DS_TAB_THANH_TOAN = "THANHTOAN"
export const KEY_DS_TAB_XET_NGHIEM = "XET_NGHIEM"
export const DS_NOI_TRU_TIEP_DON = "DS_NOI_TRU_TIEP_DON";
export const DS_NOI_TRU_PHONG_BENH = "DS_NOI_TRU_PHONG_BENH";
export const KEY_DS_TAB_PHAU_THUAT_THU_THUAT = "KEY_DS_TAB_PHAU_THUAT_THU_THUAT"
export const KEY_DS_TAB_CDHA_TDCN = "DS_CDHA_VA_TDCN";
export const KEY_DS_TAB_KHAM_DOAN = "KEY_DS_TAB_KHAM_DOAN";
export const KEY_DS_TAB_HOP_DONG = "KEY_DS_TAB_HOP_DONG";
export const DM_TAI_KHOAN = "DM_TAI_KHOAN"
export const DM_KHOA_PHONG = "DM_KHOA_PHONG"
export const DM_NHAN_VIEN = "DM_NHAN_VIEN"
export const DM_DICH_VU_GIA = "DM_DICH_VU_GIA"
export const DM_THIET_BI_CLS = "DM_THIET_BI_CLS"
export const DM_CO_SO_KHAM_CHUA_BENH = "DM_CO_SO_KHAM_CHUA_BENH"
export const DM_GIUONG_BENH = "DM_GIUONG_BENH"
export const KEY_DS_TAB_CHI_TIET_DV_DS_PHIEU = "CHITIETDV_DSPHIEU";
export const KEY_DS_TAB_BENH_AN = "KEY_DS_TAB_BENH_AN";
export const KEY_DS_DANH_MUC_TIEP_DON = "KEY_DS_DANH_MUC_TIEP_DON";
export const KEY_THUC_HIEN_CHUYEN_KHOA = "KEY_THUC_HIEN_CHUYEN_KHOA";
export const TOKEN = "TOKEN";
export const MAX_SIZE = 9999999;

export const APP_CONFIGURATION_KEYS = {
  ADMIN_URL: "adminUrl",
  API_URL: "apiUrl",
  SSO_URL: "ssoUrl",
  TTS_URL: "ttsUrl",
  WAREHOUSE_URL: "wmsApi",
  INS_URL: "insApi",
  INS_LOOKUP: "insLookup",
  INPATIENT_URL: "inpatientApi",
  OAUTH_CLIENT_URL: "oauthClientUrl",
  REPORT_URL: "reportUrl",
  INTEGRATION_URL: "integrationUrl",
  EMR_URL: "emrUrl",
};

export const REGEX = {
  TEN: /^[^~`!@#$%^&*()+=\-[\]\\';,/{}|\\":<>?\d]+$/,
  AZ_09: /^[a-zA-Z0-9]*$/,
  CHARACTER20: /^.{6,20}$/,
  CHARACTER9or12: /^\d{9}(\d{3})?$/,
  CHARACTER50: /^.{1,50}$/,
  CHARACTER255: /^.{1,255}$/,
  CHECK_PHONE: /^(0|\+84)\d{9,10}$/,
  YEAR: /^.{4,5}$/,
}
export const NUMBER_EXCEPT_THIS_SYMBOLS = ["e", "E", "+", "-", "."]
export const TITLE_TYPE = 2
export const POSITION_TYPE = 3
export const STATUS_TYPE = 4

export const CODE = {
  SUCCESS: 200,
  ISE: 500,
  ERROR_CODE_400001: 400001,
  BAD_REQUEST: 400,
  ERROR_CODE_400: 400,
}
export const TRANG_THAI = {
  CHUA_THANH_TOAN: 1,
  DA_HOAN_THANH: 2,
  TAM_UNG: 3,
}

export const KEY = {
  ENTER: 'Enter',
  SPACE: 'Space',
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  DELETE: "Delete",
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
}

export const SIMPLE_CATEGORY_TYPE = {
  DAN_TOC: 1,
  CHUC_DANH: 2,
  CHUC_VU: 3,
  LY_DO_KHAM: 3,
  TRANG_THAI_NHAN_VIEN: 4,
  MOI_QUAN_HE: 7,
  LOAI_TIEP_NHAN: 8,
  LOAI_GIA: 9,
  TUYEN: 10,
  MA_KV: 11,
  TUYEN_CHUYEN: 12,
  LY_DO_CHUYEN: 13,
  DOI_TUONG: 15,
  QUOC_GIA: 16,
  NGHE_NGHIEP: 18,
  GIOI_TINH: 19,
  TUYEN_KCB: 20,
  LOAI_SO: 24,
  TINH_TRANG_HON_NHAN: 39,
  LOAI_NGAY_GIUONG: 25,
  LOAI_HOI_CHAN: 45,
  DOI_TUONG_DICH_VU: 56,
  POLICY_CODE: 57,
  HINH_THUC_THANH_TOAN: 21,
  LOAI_PHIEU_VIEN_PHI: 22,
  TINH_HUYEN_XA_CU: 54,
  LOAI_HINH_KCB: 87,
}

export const TERM_CLASS_IDS = {
  KHAM_BENH: 1,
  XET_NGHIEM: 2,
  MAU: 3,
  ICD10: 4,
  CDHA: 5,
  PTTT: 6,
  KQDT: 7,
  HTXT: 8,
  LOAI_MO_BENH_AN: 11,
  HT_CHUYEN_TUYEN: 15,
  LD_CHUYEN_TUYEN: 16,
  LD_CHUYEN_TUYEN_BS: 17,
  CHUYEN_TUYEN: 18,
  Y_HOC_CO_TRUYEN: 34,
  VAN_CHUYEN: 31,
  NGAY_GIUONG_CHUYEN_KHOA: 32,
  DV_KHAC: 33,
};

export const TERM_TYPE = {
  XET_NGHIEM: 2,
  CDHA: 4,
  PTTT: 5,
};

export const LEVEL =  {
  KHOA: 1,
  PHONG: 2,
};

export const LOAI_PHONG = {
  PHONG_KHAM_BENH: 1,
  PHONG_XET_NGHIEM: 2,
  PHONG_CDHA: 5,
  LAY_MAU: 6,
  DIEU_TRI: 7,
  PTTT: 4,
};

export const ID_DANG_KY_KHAM = {
  KHAM_BENH: 1,
  CAP_CUU:2
}

export const ORDER_TYPE_ID = {
  CONG_KHAM: "1",
  XET_NGHIEM: "2",
  CDHA: "4",
  THUOC: "3",
  VAT_TU: "7",
  CHUYEN_KHOA: "5",
  DV_KHAC: "10",
  KHAM_KET_HOP: '9',
  MAU: "12",
  DV_DIEU_TRI: "31",
  THUOC_DIEU_TRI: "32",
  VAT_TU_DIEU_TRI: "33",
}

export const CODE_SELECT = {
  QG_VIET_NAM: "000",
  DT_KINH: "1",
  LTT_BENH_MOI: "TIEPNHAN1",
  LTT_TAI_KHAM: "TIEPNHAN2",
}

export const DEFAULT_PAGE_INDEX = 1
export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_TOTAL_PAGES = 0
export const DEFAULT_TOTAL_ELEMENTS = 0
export const MAX_PAGE_SIZE = 99999
export const SEARCH_OBJECT_MAX_SIZE = {
  pageIndex: DEFAULT_PAGE_INDEX,
  pageSize: MAX_PAGE_SIZE,
}

export const SELECTION_MODE = {
  SINGLE: 'single',
  MULTI: 'multi',
  MULTI_TABLE: 'multiline',
  SINGLE_NO_RADIO_BUTTON: 'singleNoRadioButton',
}

export enum TYPE {
  OBJECT = "object",
  STATUS = "status",
  STRING = "string",
  TEXT = "text",
  NUMBER = "number",
  INPUT = "input",
  DATE = "date",
  TEXTAREA = "textarea",
  SELECT = "select",
  SINGLE = "single",
  MULTI = 'multi',
  MULTILINE = "multiline",
  MODULE = "module",
  PASSWORD= "password",
  EXCEL = "EXCEL",
  WORD = "WORD",
  MONEY = "MONEY",
  NUMBER_FLOAT = "NUMBER_FLOAT",
  SINGLE_NO_RADIO_BUTTON = 'singleNoRadioButton',
}

export const RESPONSE_MESSAGE = {
  ADD: {
    SUCCESS: 'Thêm thành công',
  },
  UPDATE: {
    SUCCESS: 'Cập nhật thành công',
  },
  DELETE: {
    SUCCESS: "Xóa thành công"
  },

  ERROR: 'Xảy ra lỗi, vui lòng thử lại',
  SUCCESS: 'Yêu cầu thực hiện thành công',
}

export const INPUT_VALUE = {
  BENH_NHAN: {
    LOAI_DOI_TUONG: "benhNhanCase.loaiDoiTuong",
    LOAI_TIEP_NHAN: "benhNhanCase.loaiTiepnNhan"
  }
}

export const CODE_SUCCESS = 200
export const ERROR_MESSAGE = "Có lỗi xảy ra, vui lòng thử lại!"

export const CHI_DINH_DV_TIEP_NHAN = 'CHI_DINH_DV_TIEP_NHAN';
export const CHI_DINH_DV_TIEP_DON = 'CHI_DINH_DV_TIEP_DON';

export const VARIABLE_STRING = {
  PROVINCE: "province",
  DISTRICT: "district",
  COMMUNE: "commune",
  WARD: "ward",
  DAN_TOC: "danToc",
  QUOC_TINH: "quocTich",
  LOAI_TIEP_NHAN: "loaiTiepNhan",
  TEN_DICH_VU: "tenDichVu",
  PHONG_KHAM: "phongKham",
  BMI: "BMI",
  CODE_GIOI_THIEU: "TUYEN4",
  QUANTITY: "quantity",
  PROMOTION_PERCENT: "promotionPercent",
  XU_TRI: "xuTri",
  KHAM_BO_PHAN: "khamBoPhan",
  SINH_HIEU: "sinhHieu",
  BENH_CHINH: "benhChinh",
  BENH_PHU: "benhPhu",
  DEPARTMENT: "department",
  ROOM: "room",
  TRANG_THAI: "status",
  LOAI_HANG_HOA: "loaiHangHoa",
  QDTT: "QDTT",
  NOI_SINH: "noiSinh",
  CHUYEN_KHOA: "chuyenKhoa",
  RA_VIEN: "raVien",
  XIN_VE: "xinVe",
  DUA_VE: "duaVe",
  TRON_VIEN: "tronVien",
  CHUYEN_TUYEN: "chuyenTuyen",
  TU_VONG: "tuVong",
  HINH_THUC_XU_TRI: "hinhThucXuTri",
  DOUBLE_CLICK: "doubleClick",
  GENDER: "gender",
  DOI_TUONG: "visitObjectType",
  PATIENT: "patient",
  VISIT: "visit",
  INSURANCE: "insurance",
  LST_ORDERS: "orders",
  CHUYEN_PHONG_KHAM: "chuyenPhongKham",
  TINH_HUYEN_XA: "administrativeUnit",
  PAGE_SIZE: "pageSize",
  PAGE_INDEX: "pageIndex",
  INITIAL_DETAIL_VALUES: 'initialDetailValues',
  INS_LOOKUP: 'insLookup',
  ADDITIONAL_FORMS: 'additionalForms',
}

export const TRANG_THAI_KHAM_BENH = [
  { status: 0, name: "Chờ khám" },
  { status: 1, name: "Đang khám" }
]

export enum STATUS_KHAM_BENH {
  CHO_KHAM = 0,
  DANG_KHAM = 1,
}

export const STATUS_ACTION = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  DELETE: "DELETE",
  IMPORT: "IMPORT",
};

export enum TYPE_INPUT {
  STRING = "string",
  NUMBER = "number",
  OBJECT = "object",
}

export const TRANG_THAI_PHIEU = {
  CHUA_THUC_HIEN: 1,
  DA_LAY_MAU: 2,
  DA_THUC_HIEN_VA_TRA_KET_QUA: 3,
  DA_THUC_HIEN_VA_CHUA_TRA_KET_QUA: 4,
}

export const LIST_COLOR_TRANG_THAI_PHIEU = [
  {
    code: TRANG_THAI_PHIEU.CHUA_THUC_HIEN,
    name: "red",
  },
  {
    code: TRANG_THAI_PHIEU.DA_LAY_MAU,
    name: "purple",
  },
  {
    code: TRANG_THAI_PHIEU.DA_THUC_HIEN_VA_TRA_KET_QUA,
    name: "green",
  },
  {
    code: TRANG_THAI_PHIEU.DA_THUC_HIEN_VA_CHUA_TRA_KET_QUA,
    name: "orange",
  },
]

export const MESSAGE = {
  CONFIRM: {
    XOA_PHIEU: "Bạn có chắc chắn muốn xóa phiếu này không?",
    XOA_DON_THUOC: "Bạn có chắc chắn muốn xóa đơn thuốc này không?",
    BO_DICH_VU_KHONG_LAM: "Bạn có chắc chắn muốn bỏ dịch vụ này không?",
    HUY_GUI_PHIEU_CDHA: "Bạn có chắc chắn muốn hủy gửi phiếu chẩn đoán hình ảnh này không?",
    HUY_GUI_DON_THUOC: "Bạn có chắc chắn muốn hủy gửi đơn thuốc này không?",
    HUY_GUI_PHIEU_MAU: "Bạn có chắc chắn muốn hủy gửi phiếu máu này không?",
  },
  SUCCESS: {
    HUY_GUI_PHIEU: "Đã hủy gửi phiếu thành công!",
    HUY_DON_THUOC: "Đã hủy gửi đơn thuốc thành công!",
    GUI_PHIEU: "Gửi phiếu thành công!",
    GUI_DON_THUOC: "Đã gửi đơn thuốc thành công!",
    XOA_PHIEU: "Xóa phiếu thành công!",
  },
  WARNING: {
    THAY_THE_DICH_VU_KHAC: "Dịch vụ không được phép thay thế!",
    HUY_GUI_PHIEU: "Không thế hủy phiếu vì có dịch vụ đang thực hiện!"
  },
  REQUIRED: "Trường này là bắt buộc"
}

export const PATH_NAME = {
  KHAM_BENH: "/kham-benh",
  HANH_CHINH: "/hanh-chinh",
};
export const BOOLEAN_TYPE_IN_NUMBER = {
  TRUE: 1,
  FALSE: 2
};
export const CODE_GENERATE_FORM = {
  loaiDichVuQuantriHeThong:'SVC',
  khoaQuanTriheThong: 'DEPT',
  xuTriRaVien: 'xuTriRaVien',
};
export const overflowHiddenTable = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}

export const textSystem = {
  fontWeight: "400",
  color: "#333",
  padding: "0.5rem",
}

export const FORM_CODE = {
  SO_KHAM_SUC_KHOE: 'soKhamSucKhoe',
}

export const CODE_MENU = {
  SUA_SO_LUONG: {
    MOT: 1,
    HAI: 2,
    BA: 3,
    BON: 4,
    NHAP_SO_LUONG: "nhapSoLuong"
  },
  SUA_GIA: "suaGia",
  GHI_CHU: "ghiChu",
  XOA_THUOC: "xoaThuoc",
  XOA_DICH_VU: "xoaDichVu",
  BENH_CHINH: "benhChinh",
  XOA_BENH: "xoaBenh"
};

export const DISPLAY_INVOICES = {
  HUY: "(H)",
  AM: "(-)",
  DUONG: "(+)"
}

export const UU_TIEN = {
  TRUE: 0,
  FALSE: 1
};

export const MENU_ACTION = {
  KHAM_BENH: 1,
  XN_CDHA: 2
}

export const APP_DATE_TIME_FORMAT = 'HH:mm DD/MM/YYYY';
export const APP_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_TIME_FORMAT = 'HH:mm';
export const APP_TIMESTAMP_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'YYYY-MM-DD';

export const FILE_EXTENSION = {
  IMAGE: 'image/*',
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const STATUS_COLOR = {
  CHUA_LAY_MAU: "#dc3545",
  DA_LAY_MAU: "#ac07ff",
  LAY_MAU: "#28a745"
}

export const STATUS_CANCEL = {
  START: "order_start",
  KTV_CANCEL: "order_stop_executing",
  EXCUTING: "order_executing",
  BS_CANCEL: "order_canceled",
  APPROVED: "test_approved"
};


export const STATUS_TEST = {
  START: "test_start",
  APPROVED: "test_approved"
};
export const TERMS_CLASS_IDS_DICH_VU = `${TERM_CLASS_IDS.XET_NGHIEM},${TERM_CLASS_IDS.CDHA},${TERM_CLASS_IDS.PTTT}`;

export const INDEX_DB_KEY_TERM_MAPPER = {
  'listDVKhamBenh':TERM_CLASS_IDS.KHAM_BENH,
  'listKQDT': TERM_CLASS_IDS.KQDT,
  'listICD10': TERM_CLASS_IDS.ICD10, 
  'listHTXT': TERM_CLASS_IDS.HTXT, 
  'listDichVu': TERMS_CLASS_IDS_DICH_VU,
};

export const WORKFLOW_ORG_CONFIG_CODE = {
  FORM_INFO_PAYMENT_ASSIGN: "FORM_INFO_PAYMENT_ASSIGN",
  FORM_INFO_PAYMENT: "FORM_INFO_PAYMENT",
  FORM_INFO_PAYMENT_PE: "FORM_INFO_PAYMENT_PE",
  ENABLE_AUTO_SPLIT_SERVICE: "ENABLE_AUTO_SPLIT_SERVICE",
};

export const DEPARTMENT_CONFIG_TYPE = {
  FULFILL: 1,
  SAMPLE: 2,
};

export const MENU_CONFIG_EMR = [
  'oceantech-emr-server'
];

export const MENU_CONFIG_INPATIENT = [
  'oceantech-emr-server',
  'oceantech-emr-inpatient-server',
  'oceantech-emr-outpatient-server'
];

export const DEFAULT_MOMENT_FORMAT_VALUE = {
  MONTH: 0,
  DAY: 1,
};

export const PENDING_STATUS = {
  WAITING: "WAITING",       // Đang chờ trong hàng đợi
  CALLING: "CALLING",       // Đang được gọi đến phòng khám
  IN_PROGRESS: "IN_PROGRESS",   // Đang được khám
  COMPLETED: "COMPLETED",     // Đã hoàn thành khám
  SKIPPED: "SKIPPED",       // Bị bỏ qua (có thể gọi lại)
  ABSENT: "ABSENT",       // Không đến khi được gọi
  CANCELLED: "CANCELLED",      // Hủy khám
};

export const CALL_ACTIONS = {
  CALL_NEXT: "call-next",
  RECALL: "recall",
  SKIP: "skip",
  COMPLETE: "complete",
  START: "start",
  MARK_ABSENT: "mark_absent"
};

export const AUTHORITY_CONFIG_KEYS = {
	PAYMENT: {
		MEDICAL_EXAM: 'CIS.PAYMENT.DATA_ACCESS.MEDICAL_EXAM',
		OUTPATIENT: 'CIS.PAYMENT.DATA_ACCESS.OUTPATIENT',
		INPATIENT: 'CIS.PAYMENT.DATA_ACCESS.INPATIENT',
	},
};

export const REQUEST_FROM = {
  KHAM_BENH: "KB",
  DIEU_TRI: "DT",
  HAO_PHI: "HPDVKT",
  HOAN_TRA: "HTDVKT"
};

export const REQUEST_TYPE = {
  THUOC: "THUOC",
  VAT_TU: "VATTU",
  MAU: "MAU",
};

export const ACTION_CODE = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  PRINT: "print",
}

export const COMPONENT_TYPE = {
  COMPONENT: "component",
  FILE: "file",
  FORM: "form",
  LIST: "list",
  TAB: "tab",
  REPORT: "report",
}

export const ITEM_DATA_SOURCE = {
  URL: "url",
  VALUES: "values",
}

export const E_MEDICAL_RECORD_SYSTEM = {
  ELSAGA: 'ELSAGA',
}

export const OBS_COMPLEX_CATEGORY_CODE = {
  LOAI_BENH_AN: 'loaibenhan',
  HINH_THUC_CHUYEN_TUYEN: 'dmchuyentuyen',
  CAU_HINH_GIA_DVKT: 'configpriceobject'
};

export const MEDIA_BREAK_POINTS = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400,
  XXXL: 1536,
  XXXXL: 1600,
  XXXXXL: 1920,
};

export const MODULE_TYPE = {
	OUTPATIENT: 'outpatient',
	SAMPLING: 'sampling',
	TEST: 'test',
	RISPACS: 'rispacs',
	SURGERY: 'surgery',
} as const;